$bog_ui_app_sheet $mol_page
	title \Sheet / Drawer
	body /
		<= Description $mol_view
			sub /
				<= description \Overlay panel that slides in from any edge of the screen. Click a button to open a Sheet from the corresponding side.
		<= Buttons_title $mol_view
			sub /
				<= buttons_title \Open from side
		<= Buttons $mol_view
			sub /
				<= Top_button $mol_button_minor
					click? <=> open_top? null
					sub /
						<= top_label \Top
				<= Right_button $mol_button_minor
					click? <=> open_right? null
					sub /
						<= right_label \Right
				<= Bottom_button $mol_button_minor
					click? <=> open_bottom? null
					sub /
						<= bottom_label \Bottom
				<= Left_button $mol_button_minor
					click? <=> open_left? null
					sub /
						<= left_label \Left
		<= Sheet_top $bog_ui_sheet
			showed? <=> top_showed? false
			side \top
			content /
				<= Top_content $mol_view
					sub /
						<= Top_heading $mol_view
							sub /
								<= top_heading \Sheet from Top
						<= Top_text $mol_view
							sub /
								<= top_text \This sheet slides in from the top edge. It can be used for notifications, search bars, or any content that should appear from above.
		<= Sheet_right $bog_ui_sheet
			showed? <=> right_showed? false
			side \right
			content /
				<= Right_content $mol_view
					sub /
						<= Right_heading $mol_view
							sub /
								<= right_heading \Sheet from Right
						<= Right_text $mol_view
							sub /
								<= right_text \This sheet slides in from the right edge. Commonly used for detail panels, settings, or secondary navigation.
						<= Right_form_title $mol_view
							sub /
								<= right_form_title \Example Form
						<= Right_name $mol_string
							hint \Your name
							value? <=> right_name? \
						<= Right_email $mol_string
							hint \Email address
							value? <=> right_email? \
		<= Sheet_bottom $bog_ui_sheet
			showed? <=> bottom_showed? false
			side \bottom
			content /
				<= Bottom_content $mol_view
					sub /
						<= Bottom_heading $mol_view
							sub /
								<= bottom_heading \Sheet from Bottom
						<= Bottom_text $mol_view
							sub /
								<= bottom_text \This sheet slides in from the bottom edge. Often used for mobile action sheets, media players, or supplementary content.
		<= Sheet_left $bog_ui_sheet
			showed? <=> left_showed? false
			side \left
			content /
				<= Left_content $mol_view
					sub /
						<= Left_heading $mol_view
							sub /
								<= left_heading \Sheet from Left
						<= Left_text $mol_view
							sub /
								<= left_text \This sheet slides in from the left edge. Useful for navigation drawers, filters, or side panels.
